var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreePointLeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.59995C12.6598 9.59995 13.1998 9.05995 13.1998 8.39995C13.1998 7.73995 12.6598 7.19995 11.9998 7.19995C11.3398 7.19995 10.7998 7.73995 10.7998 8.39995C10.7998 9.05995 11.3398 9.59995 11.9998 9.59995ZM11.9998 10.8C11.3398 10.8 10.7998 11.34 10.7998 12C10.7998 12.66 11.3398 13.2 11.9998 13.2C12.6598 13.2 13.1998 12.66 13.1998 12C13.1998 11.34 12.6598 10.8 11.9998 10.8ZM11.9998 14.4C11.3398 14.4 10.7998 14.94 10.7998 15.6C10.7998 16.26 11.3398 16.8 11.9998 16.8C12.6598 16.8 13.1998 16.26 13.1998 15.6C13.1998 14.94 12.6598 14.4 11.9998 14.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePointLeader);
export default __webpack_public_path__ + "static/media/threePointLeader.8c2c0deb3d6969127c5e5e4704e32591.svg";
export { ForwardRef as ReactComponent };